export default __webpack_public_path__ + "static/media/logo_PW.8b634a7b.svg";